const CSP_NONCE_META_SELECTOR = 'meta[name="csp-nonce"]';

export const getCspNonce = () => {
  if (typeof document === "undefined") return "";
  return document.head.querySelector(CSP_NONCE_META_SELECTOR)?.getAttribute("content") || "";
};

export const applyCspNonce = (element) => {
  const nonce = getCspNonce();
  if (nonce && element?.setAttribute) {
    element.setAttribute("nonce", nonce);
  }
  return element;
};
